import Vue from "vue";
import Router from "vue-router";
// import { createRouter, createWebHistory,prototype } from "vue-router";
import Home from "@/views/officalWeb/pc/Home";
import PhoneHome from "@/views/officalWeb/phone/Home";

Vue.use(Router);

// 解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push;

const originalReplace = Router.prototype.replace;

// push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject)
        return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch(err => err);
};

//replace
Router.prototype.replace = function push(location, onResolve, onReject) {
    if (onResolve || onReject)
        return originalReplace.call(this, location, onResolve, onReject);
    return originalReplace.call(this, location).catch(err => err);
};

const router = new Router({
  routes: [
    // PC端
    {
      path: "/",
      redirect: "/home", //设置默认指向的路径
      name: "主页",
      
    },
    {
      path: "/home",
      name: "Home",
      component: Home,
      meta: {
        isAdapterPhone: true
      }
    },
    // 耳鸣测评组件
    {
      path: "/pc/measurement",
      name: "pcMeasurement",
      // meta: {
      //   title: "耳鸣测评"
      // },
      component: () => import("../views/officalWeb/pc/Measurement.vue")
    },
    // 登录注册
    {
      path: "/login/:scene",
      name: "login",
      component: () => import("../views/officalWeb/pc/Login.vue")
    },
    // 导航栏-------专业技术
    {
      path: "/expertise",
      name: "expertise",
      component: () => import("../views/officalWeb/pc/Expertise.vue"),
      meta: {
        isAdapterPhone: true
      }
    },
    // 导航栏-----产品中心
    {
      path: "/shopPage",
      name: "shopPage",
      meta: {
          isAdapterPhone: true
      },
      component: () => import("../views/officalWeb/pc/ShopPage.vue")
    },
    // 导航栏-----用户中心
    {
      path: "/userCenter",
      name: "userCenter",
      component: () => import("../views/officalWeb/pc/UserCenter.vue"),
      meta: {
        isAdapterPhone: true
      }
    },
    // 导航栏-------企业新闻
    {
      path: "/articles",
      name: "articles",
      component: () => import("../views/officalWeb/pc/Articles.vue"),
      meta: {
        isAdapterPhone: true,
        keepAlive:true
      }
    },
    // 导航栏--------名医新作
    {
      path: "/doctorArticles",
      name: "doctorArticles",
      component: () => import("../views/officalWeb/pc/DoctorArticles.vue"),
      meta: {
        isAdapterPhone: true
      }
    },
    // 导航栏------听觉名医录
    {
      path: "/doctorMyPage",
      name: "doctorMyPage",
      component: () => import("../views/officalWeb/pc/DoctorMyPage.vue"),
      meta: {
        isAdapterPhone: true
      }
    },
    // 导航栏------关于我们
    {
      path: "/aboutUs",
      name: "aboutUs",
      component: () => import("../views/officalWeb/pc/AboutUs.vue"),
      meta: {
        isAdapterPhone: true
      }
    },
    // 导航栏--------下载中心
    {
      path: "/downloadCenter",
      name: "downloadCenter",
      meta: {
        isAdapterPhone: true
      },
      component: () => import("../views/officalWeb/pc/DownloadCenter.vue")
    },

    {
      path: "/orderInfo",
      name: "orderInfo",
      component: () => import("../views/officalWeb/pc/OrderInfo.vue")
    },
    {
      path: "/userInfo",
      name: "userInfo",
      component: () => import("../views/officalWeb/pc/UserInfo.vue"),
      children: [
        {
          path: "/buyInfo",
          name: "buyInfo",
          component: () => import("../views/officalWeb/pc/BuyInfo.vue")
        }
      ]
    },
    {
      path: "/doctorMyDetail",
      name: "doctorMyDetail",
      component: () => import("../views/officalWeb/pc/DoctorDetail.vue"),
      meta: {
        isAdapterPhone: true
      }
    },
    {
      path: "/bulletInBoard",
      name: "bulletInBoard",
      component: () => import("../views/officalWeb/pc/BulletinBoard.vue"),
      meta: {
        isAdapterPhone: true
      }
    },
    {
      path: "/articleDetail/:articleId/:activeName",
      name: "articleDetail",
      component: () => import("../views/officalWeb/pc/ArticleDetail.vue") ,
      meta: {
          keepAlive:true
      },
    },
    {
      path: "/qrPay",
      name: "qrPay",
      component: () => import("../views/officalWeb/pc/QrPay.vue")
    },

    // ---------------------------------------------------------------------------------

    // 移动端
    {
      path: "/phone/home",
      name: "phoneHome",
      component: PhoneHome
    },
    {
      path: "/phone/measurement",
      name: "measurement",
      meta: {
        title: "耳鸣测评"
      },
      component: () => import("../views/tencent/Measurement.vue")
    },
    {
      path: "/phone/confirmOrder",
      name: "phoneConfirmOrder",
      meta: {
        title: "确认订单"
      },
      component: () => import("../views/tencent/ConfirmOrder.vue")
    },
    {
      path: "/phone/confirmOrderContniuPay",
      name: "confirmOrderContniuPay",
      meta: {
        title: "待支付"
      },
      component: () => import("../views/tencent/ConfirmOrderContniuPay.vue")
    },
    {
      path: "/phone/addAddress",
      name: "addAddress",
      meta: {
        title: "编辑收货地址"
      },
      component: () => import("../views/tencent/AddAddress.vue")
    },
    {
      path: "/phone/addressList",
      name: "addressList",
      meta: {
        title: "收货地址"
      },
      component: () => import("../views/tencent/AddressList.vue")
    },
    {
      path: "/phone/userCenter/userHome",
      name: "userHome",
      meta: {
        title: "个人中心"
      },
      component: () => import("../views/tencent/userCenter/UserHome.vue")
    },
    {
      path: "/phone/userCenter/purchaseHistory",
      name: "purchaseHistory",
      meta: {
        title: "购买记录"
      },
      component: () => import("../views/tencent/userCenter/PurchaseHistory.vue")
    },
    {
      path: "/phone/userCenter/applyInvoice",
      name: "applyInvoice",
      meta: {
        title: "申请开票"
      },
      component: () => import("../views/tencent/userCenter/ApplyInvoice.vue")
    },
    {
      path: "/phone/userCenter/orderDetail",
      name: "orderDetail",
      component: () => import("../views/tencent/userCenter/OrderDetail.vue")
    },
    {
      path: "/phone/userCenter/privacyPolicy",
      name: "privacyPolicy",
      meta: {
        title: "隐私政策"
      },
      component: () => import("../views/tencent/userCenter/PrivacyPolicy.vue")
    },
    {
      path: "/phone/userCenter/afterShopping",
      name: "afterShooping",
      meta: {
        title: "售后服务"
      },
      component: () => import("../views/tencent/userCenter/AfterShooping.vue")
    },
    {
      path: "/phone/activity",
      name: "Activity",
      meta: {
        title: "活动"
      },
      component: () => import("../views/officalWeb/phone/Activity.vue")
    },
    {
      path: "/phone/desc",
      name: "Desc",
      meta: {
        title: "提示"
      },
      component: () => import("../views/officalWeb/phone/Desc.vue")
    },
    {
      path: "/phoneDoctorMyPage",
      name: "phoneDoctorMyPage",
      component: () => import("../views/officalWeb/phone/PhoneDoctorMyPage.vue"),
    },
    {
      path: "/phoneDoctorMyDetail",
      name: "phoneDoctorMyDetail",
      component: () => import("../views/officalWeb/phone/PhoneDoctorDetail.vue"),
    },
    {
      path: "/phone/bulletInBoard",
      name: "phoneBulletInBoard",
      component: () => import("../views/officalWeb/phone/PhoneBulletinBoard.vue"),
    },
    {
      path: "/PhoneQrPay",
      name: "PhoneQrPay",
      component: () => import("../views/tencent/PhoneQrPay.vue")
    },
    {
      path: "/phone/userCenter",
      name: "phoneUserCenter",
      component: () => import("../views/officalWeb/phone/UserCenter.vue")
    },
    {
      path: "/phone/personCenter",
      name: "phonePersonCenter",
      component: () => import("../views/tencent/userCenter/PersonCenter.vue")
    },
    {
      path: "/phone/operating",
      meta: {
        title: "产品演示"
      },
      name: "phoneOperating",
      component: () => import("../views/officalWeb/phone/Operating.vue")
    },
    {
      path: "/phone/articles",
      name: "phoneArticles",
      component: () => import("../views/officalWeb/phone/Articles.vue")
    },
    {
      path: "/phone/doctor_phone_articles",
      name: "doctorPhoneArticles",
      component: () => import("../views/officalWeb/phone/DoctorArticles.vue")
    },
    {
      path: "/phone/articleDetail/:articleId",
      name: "phoneArticleDetail",
      component: () => import("../views/officalWeb/phone/ArticleDetail.vue")
    },
    {
      path: "/phone/articleDetailMain/:articleId",
      name: "phoneArticleDetail",
      meta: {
          keepAlive:true
      },
      component: () => import("../views/officalWeb/phone/ArticleDetailMain.vue")
    },
    {
      path: "/phone/downloadCenter",
      name: "phone-DownloadCenter",
      component: () => import("../views/officalWeb/phone/DownloadCenter.vue")
    },
    {
      path: "/phone/shopPage",
      name: "phoneShopPage",
      meta: {
          title: "产品中心",
      },
      component: () => import("../views/officalWeb/phone/PhoneShopPage.vue")
    },
    {
      path: "/phone/aboutUs",
      name: "phoneAboutUs",
      component: () => import("../views/officalWeb/phone/AboutUs.vue") ,
      meta: {
        keepAlive:true
      },
    },
    {
      path: "/phone/expertise",
      name: "phoneExpertise",
      component: () => import("../views/officalWeb/phone/Expertise.vue")
    },
    {
      path: "/phone/userLogin",
      name: "phoneUserLogin",
      component: () => import("../views/officalWeb/phone/UserLogin.vue")
    },
    {
        path: "/phone/selectMeasure",
        name: "phoneselectMeasure",
        component: () => import("../views/tencent/selectMeasurement.vue")
    },
    
  ]
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router;
